import classnames from 'classnames/bind'
import { useRouter } from 'next/router'

// Libs
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Components
import Image from '@/components/common/Image'
import Icon from '@/assets/icons'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { THEME_LIST_ID } from '@/constants/theme'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IProps {
  name: string
  tips: string
  picture: string
  isEven: boolean
}

const ThemeGoBackButton = (props: IProps) => {
  const { picture, name, tips, isEven } = props
  const router = useRouter()

  const handleGoBack = () => {
    handleRoutePushWithQuery({ router, pathname: ROUTE_PATH.MALL, query: { theme_id: THEME_LIST_ID } })
  }

  return (
    <div onClick={handleGoBack} className={cx('theme-go-back-button')}>
      <div className={cx('theme-go-back-button__background')}>
        <Image src={picture} fill alt='theme-background' style={{ objectFit: 'cover' }} sizes='420px' />
      </div>
      <div
        className={cx('theme-go-back-button__background-mask', {
          'theme-go-back-button__background-mask--odd': !isEven,
          'theme-go-back-button__background-mask--even': isEven,
        })}
      ></div>

      <div className={cx('theme-go-back-button__text')}>
        <div className={cx('theme-go-back-button__text-left')}>
          <Icon.ArrowLeft />
        </div>
        <div className={cx('theme-go-back-button__text-right')}>
          <div className={cx('theme-go-back-button__title')}>{name}</div>
          <div className={cx('theme-go-back-button__tip')}>{tips}</div>
        </div>
      </div>
    </div>
  )
}

export default ThemeGoBackButton
